"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeliveryMethodTranslationKey = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
const getDeliveryMethodTranslationKey = deliveryMethod => {
  if (deliveryMethod === _globalApiClientReact.GlobalDeliveryDeliveryChannelDtoDeliveryMethod.PickupPoint) {
    return 'beautyCenterOriflame';
  }
  const stringValue = String(deliveryMethod);
  return stringValue.charAt(0).toLowerCase() + stringValue.slice(1);
};
exports.getDeliveryMethodTranslationKey = getDeliveryMethodTranslationKey;